import dayjs from 'dayjs';
import {
  JourneyChangeNoteType,
  JourneyInfo,
  JourneyFormValues,
  JourneyPlaceholder,
} from '../../../types/journey';
import { ChangeReason } from './types';
import { JourneyStatus } from '../../../types/core';

export const getChangeReason = (
  journey: JourneyInfo,
  values: JourneyFormValues,
): ChangeReason => {
  const portChanged =
    journey.arrivalPortId !== values.arrivalPortId ||
    journey.departurePortId !== values.departurePortId;

  const timeChanged =
    journey.time !== (values.time ? values.time.format('HH:mm:ss') : null);

  if (portChanged && timeChanged) {
    return {
      titleTranslationKey: 'content.port-and-time',
      noteType: JourneyChangeNoteType.ChangeTimeAndPort,
    };
  }
  if (portChanged) {
    return {
      titleTranslationKey: 'content.port',
      noteType: JourneyChangeNoteType.ChangePort,
    };
  }
  if (timeChanged) {
    return {
      titleTranslationKey: 'content.time',
      noteType: JourneyChangeNoteType.ChangeTime,
    };
  }

  return {
    titleTranslationKey: '',
    noteType: JourneyChangeNoteType.ChangeTime,
  };
};

export const generateCalendarEventId = (
  placeholder: JourneyPlaceholder,
): string =>
  [
    placeholder.routeId ?? '',
    placeholder.day,
    placeholder.time,
    placeholder.journeyId ?? '',
  ].join('-');

export const isJourneyPending = (
  journeyStatus: JourneyStatus,
  journeyDay: string,
  journeyTime: string,
) => {
  if (journeyStatus !== JourneyStatus.AsScheduled) {
    return false;
  }
  const now = dayjs();
  const journeyDate = dayjs(`${journeyDay}T${journeyTime}`);

  return journeyDate.isAfter(now);
};
